module.exports = __webpack_public_path__ + "img/ltku-2x.b8fb086.jpg";